// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoSendOutlinedSvg from "@fishx/icons-svg/es/asn/PtoSendOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoSendOutlined = function PtoSendOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoSendOutlinedSvg
  }));
};

PtoSendOutlined.displayName = 'PtoSendOutlined';
export default React.forwardRef(PtoSendOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoSendOutlined.js
// module id = 3923
// module chunks = 0